import * as React from 'react';
import Auth from '../services/auth';
import { Redirect, Route } from 'react-router-dom';

const AdminRoute = ({ component: Component, ...rest }) => {
    const auth = new Auth();
    const isLoggedIn = auth.isAuthenticated();
    const isValidLogin = auth.isValidLogin();
    const isAdmin = auth.isInADDGroup(); // Check if user is in 997-RCM-Global-Admins group

    return (
        <Route
            {...rest}
            render={props =>
                isLoggedIn && isValidLogin && isAdmin ? (
                    <Component {...props} />
                ) : isLoggedIn && isValidLogin ? (
                    // If user is logged in but not admin, redirect to dashboard with access denied message
                    <Redirect to={{ pathname: '/', state: { accessDenied: true, from: props.location } }} />
                ) : (
                    // If user is not logged in, redirect to login
                    <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                )
            }
        />
    );
};

export default AdminRoute;
